export class ContraventionQuestionModel {
  active = true;
  options: Array<object> = [];
  valuesSelected: Array<object> = [];
}

export class RadioQuestionModel {
  data: any;
  active = true;
  valueSelected: any = '0';
}

export class SelectQuestionModel {
  data: any;
  active = true;
  valueSelected: any = '0';
}

export class MultipleQuestionModel {
  data: any;
  active = true;
  valuesSelected: any;
}

export class ExplainQuestionModel {
  data: any;
  valueSelected = '0';
  active = true;
  validationSelected = '0';
  validationText = '';
}
